import { ReplyModel } from '@/models/reply.model'
import { api } from '@/services/api'

export type CreateReplyResponse = {
  reply: ReplyModel
}

export async function create(params: Omit<ReplyModel, 'id' | 'createdAt' | 'updatedAt'>) {
  const response = await api.post<CreateReplyResponse>('/replies', params)
  return response.data
}

export type UpdateReplyResponse = {
  reply: ReplyModel
}

export async function update(replyId: string, dataToUpdate: Partial<ReplyModel>) {
  const response = await api.put<UpdateReplyResponse>('/replies', {
    replyId,
    dataToUpdate
  })
  return response.data
}

export async function deleteReply(replyId: string) {
  await api.delete(`/replies/${replyId}`)
}

type FetchRepliesByCompanyParams = {
  companyId: string
  operatorId?: string
}

export type FetchRepliesByCompanyResponse = {
  replies: ReplyModel[]
}

export async function fetchRepliesByCompany(params: FetchRepliesByCompanyParams) {
  const { companyId, operatorId } = params
  const response = await api.get<FetchRepliesByCompanyResponse>('/replies/by-company-operator', {
    params: {
      companyId,
      operatorId
    }
  })
  return response.data
}
